import React, { Component } from 'react';
import { withRouter } from 'dva/router';
import { Helmet } from 'react-helmet';
import Header from '../Header/';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    // 为了动态修改meta标签，兼容移动端
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" data-react-helmet="true" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" data-react-helmet="true" />
          <meta name="description" content="DJI大疆供应商门户提供采购原则和政策，大疆供应商注册引入流程，大疆供应商投诉反馈，大疆供应商招投标，大疆供应商订单协同。大疆供应商登录入口。" data-react-helmet="true" />
          <meta name="viewport" content="width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="twitter:card" content="photo" />
          <meta name="twitter:site" content="@DJIGlobal" />
          <meta name="twitter:title" content="DJI大疆供应商门户 - 大疆采购政策、采购流程、大疆供应商协同" />
          <meta name="twitter:image" content="https://www3.djicdn.com/assets/images/v3/share/logo@400px-a66bd2836be26522b3c63e7bd1cf324d.png?from=cdnMap" />
          <meta property="og:site_name" content="DJI Official" />
          <meta property="og:url" content="https://srm.dji.com" />
          <title>DJI大疆供应商门户 - 大疆采购政策、采购流程、大疆供应商协同</title>
        </Helmet>
        {this.props.header ? <Header {...this.props} /> : null}
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default withRouter(ScrollToTop);
